module.exports = __webpack_public_path__ + "static/power2-3@2x-7e3e644173312b57edc6121edad8cd36.png";